export interface BallotColorInfo {
  id: string
  dignity: string
  shortLabel: string
  colorName: string
  color: string
  candidateDignityIds: string[]
}

export const ballotColors = [
  {
    id: 'prefecto',
    dignity: 'Prefecto/a y viceprefecto/a',
    shortLabel: 'Prefectura',
    colorName: 'Café',
    color: '#c9936b',
    candidateDignityIds: ['prefecto', 'prefectura', 'viceprefecto'],
  },
  {
    id: 'alcalde',
    dignity: 'Alcaldesa / Alcalde',
    shortLabel: 'Alcaldía',
    colorName: 'Gris',
    color: '#8f969d',
    candidateDignityIds: ['alcalde', 'alcaldesa', 'alcaldia'],
  },
  {
    id: 'concejales-urbanos',
    dignity: 'Concejales urbanos',
    shortLabel: 'Concejalía urbana',
    colorName: 'Verde',
    color: '#42b878',
    candidateDignityIds: ['concejal', 'concejales-urbanos', 'concejal-urbano'],
  },
  {
    id: 'concejales-rurales',
    dignity: 'Concejales rurales',
    shortLabel: 'Concejalía rural',
    colorName: 'Celeste',
    color: '#7ed3f2',
    candidateDignityIds: ['concejales-rurales', 'concejal-rural'],
  },
  {
    id: 'junta-parroquial',
    dignity: 'Vocales de junta parroquial rural',
    shortLabel: 'Junta parroquial',
    colorName: 'Verde claro',
    color: '#a8bb65',
    candidateDignityIds: ['junta-parroquial', 'vocal-junta-parroquial'],
  },
  {
    id: 'cpccs-mujeres',
    dignity: 'CPCCS mujeres',
    shortLabel: 'CPCCS mujeres',
    colorName: 'Rosa',
    color: '#f28ab8',
    candidateDignityIds: ['cpccs-mujeres'],
  },
  {
    id: 'cpccs-hombres',
    dignity: 'CPCCS hombres',
    shortLabel: 'CPCCS hombres',
    colorName: 'Amarillo',
    color: '#f4d466',
    candidateDignityIds: ['cpccs-hombres'],
  },
  {
    id: 'cpccs-exterior',
    dignity:
      'CPCCS pueblos y nacionalidades indígenas, afroecuatorianos o montubios y ecuatorianos en el exterior',
    shortLabel: 'CPCCS Pueblos y nacionalidades...',
    colorName: 'Naranja',
    color: '#f28c2f',
    candidateDignityIds: ['cpccs-exterior', 'cpccs'],
  },
] satisfies BallotColorInfo[]

function normalizeCandidateDignityId(dignityId: string) {
  return dignityId
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .trim()
}

export function getCandidateDignityGroupId(dignityId: string) {
  const normalized = normalizeCandidateDignityId(dignityId)
  const exactBallot = ballotColors.find((item) =>
    item.candidateDignityIds.some((id) => normalized === id),
  )
  if (exactBallot) return exactBallot.id

  const partialMatch = ballotColors
    .flatMap((item) => item.candidateDignityIds.map((id) => ({ id, groupId: item.id })))
    .sort((a, b) => b.id.length - a.id.length)
    .find(({ id }) => normalized.includes(id))

  return partialMatch?.groupId ?? normalized
}

export function isNationalCandidateDignity(dignityId: string) {
  return getCandidateDignityGroupId(dignityId).startsWith('cpccs-')
}

export function getBallotColorByCandidateDignity(dignityId: string) {
  const groupId = getCandidateDignityGroupId(dignityId)
  return ballotColors.find((item) => item.id === groupId) ?? ballotColors[1]
}

export function getElectionResultDignityOptions() {
  return ballotColors.map((item) => ({
    id: item.id,
    label: item.shortLabel,
  }))
}
